import { API_BASE, apiSlice } from '@/redux/api-slice'

const url = API_BASE + 'v2/CwsDirect'

const cwsDirectApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getDirectLinkMediaFileBinary: build.query<string, string>({
      query: (mediaStringId: string) => ({
        url: `${url}/ui?mediaStringId=${mediaStringId}`,
        responseHandler: (response) => handleMediaFileResponse(response),
      }),
    }),
  }),
})

export const { useLazyGetDirectLinkMediaFileBinaryQuery } = cwsDirectApi

const getFileName = (header: string | null) => {
  const regexp = /filename\*\s*=\s*UTF-8''([^;]+)/i
  return (
    (header?.match(regexp)?.[1] &&
      decodeURIComponent(header.match(regexp)![1])) ||
    header?.match(/filename="?([^";]+)"?/i)?.[1] ||
    'download'
  )
}

const handleMediaFileResponse = async (response: Response) => {
  if (!response.ok) throw new Error(`HTTP ${response.status}`)
  const filename = getFileName(response.headers.get('Content-Disposition'))

  const blob = await response.blob()
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')

  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}
